import { memo } from "react";
import {
  Button,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import { AvForm } from "availity-reactstrap-validation";

const AnonymizationModal = function (props) {

  const { t, isOpen, acceptDeletion, close, isLoading } = props;

  return (
    <>
      <Modal size="lg" scrollable={true} isOpen={isOpen} backdrop="static">
        {/* header */}
        <ModalHeader toggle={() => close()}>{t("Anonymize Data")}</ModalHeader>

        {/* body */}
        <ModalBody>
          <AvForm className="needs-validation">
            <Row>
              <Label>{t("Do you really want to anonymize your data?")}</Label>
            </Row>

            <ModalFooter>
              <Button
                color="danger"
                className="waves-effect waves-light"
                type="submit"
                disabled={isLoading}
                onClick={() => {
                  acceptDeletion();
                }}
              >
                {t("Yes").toUpperCase()}
              </Button>
              <Button
                color="secondary"
                className="waves-effect waves-light"
                type="button"
                onClick={() => {
                  close();
                }}
              >
                {t("Cancel").toUpperCase()}
              </Button>
            </ModalFooter>
          </AvForm>
        </ModalBody>
      </Modal>
    </>
  );
};

export default memo(AnonymizationModal);
